import React, { useState, useEffect } from "react";
import {
  useGetSellerCartDataQuery,
  useAcceptPaymentBySellerMutation,
  useNegotiationTimelineMutation,
} from "./ProcurementApiSlice";

import {
  Popover,
  IconButton,
  Typography,
  Button,
  Card,
  CardContent,
  Grid,
  Box,
  useMediaQuery,
  useTheme,
  Radio,
  RadioGroup,
  FormControlLabel,
  Divider,
} from "@mui/material";

import PropTypes from "prop-types";

import { faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import SellerInterestedBuyerList from "./SellerInteredBuyerList";
import SellerDependentCart from "./SellerDependantCart";
import SellerDispatch from "./SellerDispatch";
import { Modal, Spinner, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NoData from "features/MobileProcurement/NoData";
import CancelIcon from "@mui/icons-material/Cancel";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { toast } from "react-toastify";
// import InfoIcon from '@mui/icons-material/Info';
import InvoiceGenerationAdmin from "./InvoiceGenerationAdmin";
import SkeletonLoader from "./SkeletonLoader";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import BuyerInterestedForSeller from "./BuyerInterestedForSeller";
import { Modal as ModalAnt } from "antd";
import { DetailDescriptionSeller } from "./DetailDescriptionSeller";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
const SellerCart = ({ user_id, activeCard, setActiveCard }) => {
  let initialEvent = " ";

  const {
    data: getStockWiseCommodity,
    isLoading,
    isFetching,
    refetch,
  } = useGetSellerCartDataQuery(
    { user_id: user_id, initialEvent: initialEvent },
    { refetchOnMountOrArgChange: true }
  );
  const [acceptPayment] = useAcceptPaymentBySellerMutation();
  const [BuyersActiveId, setBuyersActive] = useState("");
  const [CommodityData, setCommodityData] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, per_page: 10 });
  const [value, setValue] = useState("self");
  const [BuyersList, setBuyersActiveList] = useState("");
  const [FullList, setFullList] = useState([]);
  const [show, setShow] = useState(false);
  const [qualityParams, setQualityParams] = useState("");
  const [approveloader, setApproveLoader] = useState(false);
  const theme = useTheme();
  const [isRefetching, setIsRefetching] = useState(false);

  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Check if the screen is small
  const [InterestedBuyerModal, setInterestedBuyerModal] = useState(false);
  console.log("isLoading", isLoading);
  const handleClose = () => {
    setShow(false);
    // refetch();
  };
  const [negotiationView, setNegotiationView] = useState(null);

  const [anchorEl, setAnchorEl] = useState(false);
  const [triggerTab2Api, setTriggerTab2Api] = useState(false);

  const [anchorElPayment, setAnchorElPayment] = useState(null);
  const handlePopoverClosePayment = () => {
    setAnchorElPayment(null);
  };
  const handlePopoverOpenPayment = (event, list) => {
    setAnchorElPayment(event.currentTarget);
    setFullList(list);
    setAnchorElDo("");
  };
  useEffect(() => {
    if (value !== "buyer") {
      refetch();
    }
  }, [activeCard, value]);
  useEffect(() => {
    if (getStockWiseCommodity) {
      setCommodityData(getStockWiseCommodity?.data?.results);
    }
  }, [getStockWiseCommodity, activeCard, value]);

  const handleDispatchModal = (list) => {
    setShow(true);
    setFullList(list);
    setAnchorElDo(null);
    setstockUserId(list.created_by);
    setstockCropId(list.crop_code);
  };
  const [anchorElDo, setAnchorElDo] = useState(null);
  const handleUploadIconClick = (event, list) => {
    setAnchorElDo(event.currentTarget);
    setFullList(list);
  };
  const handleCloseDo = () => {
    setAnchorElDo(null);
  };
  const [anchorElInvoice, setAnchorElInvoice] = useState(null);
  const handleGenerateInvoice = (event, list) => {
    setAnchorElInvoice(event.currentTarget);
    setFullList(list);
    setQualityParams(list.quality_parameters);
  };
  const handleCloseInvoice = () => {
    setAnchorElInvoice(null);
  };
  const [BillModal, setBillModal] = useState(false);
  const [stockUserId, setstockUserId] = useState("");
  const [stockCropId, setstockCropId] = useState("");
  const handleShipment = (row) => {
    console.log("row data", row);
    setAnchorElDo(null);
    setBillModal(true);
    // setprocId(row.id);
    setFullList(row);
    setstockUserId(row.created_by);
    setstockCropId(row.crop_code);
  };

  const handleChangeTabs = (newValue) => {
    setValue(newValue);
  };
  const handleViewPdf = (url) => {
    window.open(url, "_blank");
  };
  const [paymentsheetloader, setpaymentsheetloader] = useState(false);
  const handleAccept = (val, item, index) => {
    setpaymentsheetloader(true);
    let payload;
    if (val === "Payment Received")
      payload = {
        status: val,
        entity_type: "Seller",
        payment_id: item.id,
      };
    else
      payload = {
        status: val,
        entity_type: "Seller",
      };
    setApproveLoader(true);
    let id = FullList.trade_procCode;
    acceptPayment({ id: id, payload: payload })
      .unwrap()
      .then(async (data) => {
        toast.success("Successfully Updated !!");
        setAnchorElPayment(null);
        await refetch();
        setApproveLoader(false);
        setpaymentsheetloader(false);
        setAnchorElPayment(null);
      })
      .catch((error) => {
        toast.error("Something went wrong !!");
        setApproveLoader(false);
        setpaymentsheetloader(false);
        return;
      });
  };
  const handleStatus = (row) => {
    const {
      status,
      dispatch_status,
      delivery_status,
      document_status,
      payments,
    } = row || {};

    let displayStatus = status;
    if (status === "Closed") {
      return displayStatus;
    }
    if (dispatch_status !== "Pending" && delivery_status === "Pending") {
      displayStatus = dispatch_status;
    } else if (delivery_status !== "Pending" && dispatch_status !== "Pending") {
      displayStatus = delivery_status;
    }
    if (document_status.payment_sheet_partner && status === "Completed") {
      displayStatus = status;
    }
    if (document_status.payment_sheet_partner && status !== "Completed") {
      displayStatus = payments.partner_status;
    }
    // setStatus(displayStatus)
    return displayStatus;
  };
  const handleInterestedBuyerModal = (trade) => {
    setBuyersActive(trade.id);
    setBuyersActiveList(trade);
    setInterestedBuyerModal(true);
  };
  const handleCloseSellerModal = () => {
    setNegotiationView(null);
    setInterestedBuyerModal(false);
  };
  //  const handleRefreshButton=()=>{
  //   if(value==="buyer"){
  //   setTriggerTab2Api(true)
  //   }
  //   else if(value==="self")
  //   setTriggerTab2Api(false)
  //    refetch()
  //  }
  const [alternateClick, setAlternateClick] = useState(false);
  const handleRefreshButton = async () => {
    if (value === "buyer") {
      setAlternateClick(!alternateClick);

      setTriggerTab2Api(true);
    } else if (value === "self") {
      setTriggerTab2Api(false);
      setIsRefetching(true); // Set loading to true before refetching
      await refetch(); // Wait for API response
      setIsRefetching(false); // Turn off loading after refetch
    }
  };
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          padding: isMobile ? "0px" : "16px",
          // backgroundColor: "#F5F5F5",
          borderRadius: "8px",
          // boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* <Typography
        variant="h5"
     
      >
                <div className="heading-title">

                <h5 className="text-warning" style={{ margin: 0 }}>ONGOING TRADES</h5>
                </div>
      </Typography> */}

        <RadioGroup
          row
          value={value}
          onChange={(e) => handleChangeTabs(e.target.value)}
          sx={{
            display: "flex",
            flexDirection: { xs: "column", lg: "row" },
            gap: 2,
            alignItems: "center",
          }}
        >
          <FormControlLabel
            value="self"
            control={<Radio color="warning" />}
            label={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <img
                  src="https://cdn-icons-png.flaticon.com/512/12925/12925052.png"
                  alt="Self Initiated"
                  style={{ width: 20, height: 20 }}
                />
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: value === "self" ? "orange" : "black",
                    fontWeight: value === "self" ? "bold" : "normal",
                  }}
                >
                  Trade Initiated by Me
                </Typography>
              </Box>
            }
          />
          <FormControlLabel
            value="buyer"
            control={<Radio color="warning" />}
            label={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <img
                  src="https://cdn-icons-png.flaticon.com/256/8712/8712832.png"
                  alt="Buyer Initiated"
                  style={{ width: 20, height: 20 }}
                />
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: value === "buyer" ? "orange" : "black",
                    fontWeight: value === "buyer" ? "bold" : "normal",
                  }}
                >
                  Trade Initiated by Buyer
                </Typography>
              </Box>
            }
          />
        </RadioGroup>
        <Button
          variant="contained"
          onClick={() => handleRefreshButton()}
          className="bg-transparent text-black mx-2 p-2"
          style={{
            border: "1px solid #829999",
            color: "#343737",
          }}
        >
          <FontAwesomeIcon icon={faRotateLeft} />
        </Button>
      </Box>
      <Box sx={{ p: 2 }}>
        <div
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            backdropFilter: "blur(8px)",
          }}
        >
          {value === "self" ? (
            <>
              {isLoading || isRefetching || isFetching ? (
                <SkeletonLoader />
              ) : CommodityData?.length > 0 ? (
                <Grid container spacing={2} style={{ marginTop: "-40px" }}>
                  {CommodityData?.map((row, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                      <Card
                        variant="outlined"
                        sx={{
                          padding: 2,
                          borderRadius: "12px",
                          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                          transition: "transform 0.3s",
                          "&:hover": { transform: "scale(1.02)" },
                          paddingBottom: 0,
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: { sm: "row" },
                            alignItems: { xs: "center", sm: "flex-start" },
                            marginBottom: 1.5,
                          }}
                        >
                          {row.image_url && (
                            <Box
                              component="img"
                              src={row.image_url}
                              alt={row.crop_name}
                              sx={{
                                width: "70px",
                                height: "70px",
                                objectFit: "cover",
                                borderRadius: "8px",
                                marginBottom: { xs: 1, sm: 0 },
                                marginRight: { sm: 2 },
                              }}
                            />
                          )}

                          <Box
                            sx={{
                              flex: 1,
                              textAlign: { xs: "center", sm: "left" },
                            }}
                          >
                            <Typography
                              variant="subtitle1"
                              sx={{ fontWeight: 600 }}
                            >
                              {row.crop_name.replace(/_/g, " ")}
                            </Typography>
                            <Typography
                              variant="caption"
                              sx={{ color: "text.secondary" }}
                            >
                              Created: {row.created_at.slice(0, 10)}
                            </Typography>
                          </Box>
                          {(row.status === "Purchase Order Uploaded" ||
                            row?.document_status?.b2s_invoice ||
                            row.status === "Invoice In Progress") && (
                            <IconButton
                              size="small"
                              onClick={(e) => handleUploadIconClick(e, row)}
                              sx={{
                                alignSelf: "flex-start",
                                marginLeft: "auto",
                              }}
                            >
                              <MoreVertIcon />
                            </IconButton>
                          )}
                        </Box>

                        <CardContent sx={{ paddingTop: 0 }}>
                          {/* Quantity and Price */}
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              flexDirection: { sm: "row" },

                              flexWrap: "wrap",
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{ color: "text.secondary" }}
                            >
                              Quantity:{" "}
                              <strong>
                                {row?.final_quantity === 0.0 ||
                                row?.final_quantity === 0
                                  ? row?.quantity
                                  : row?.final_quantity}{" "}
                                {row.unit_of_measure}
                              </strong>
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{ color: "text.secondary" }}
                            >
                              Price/Unit:
                              <strong>
                                {" "}
                                ₹{" "}
                                {row?.final_price === 0.0 ||
                                row?.final_price === 0
                                  ? row?.price
                                  : row?.final_price}
                              </strong>
                            </Typography>
                          </Box>

                          {/* <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexWrap: { xs: "wrap", sm: "nowrap" },
                  marginBottom: 1,
                }}
              >
                <Typography variant="caption" sx={{ display: "flex", alignItems: "center" }}>
                  <AccessTimeIcon fontSize="small" sx={{ marginRight: 0.5 }} />
                  Payment {row.delivery_and_payment_detail.payment_type} {row.delivery_and_payment_detail.payment_type==="D+"?(row.delivery_and_payment_detail.payment_timeline) +" days":""}

                </Typography>
                <Typography variant="caption">
                  Est Delivery: {row.delivery_and_payment_detail.delivery_timeline} Days
                </Typography>
              </Box> */}

                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              flexWrap: { xs: "wrap", sm: "nowrap" },
                            }}
                          >
                            <Typography
                              variant="caption"
                              sx={{ fontWeight: 500, color: "#69829f" }}
                            >
                              Status:{" "}
                              <span style={{ color: "orange" }}>
                                {handleStatus(row)}
                              </span>
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                fontWeight: 500,
                                color: "primary.main",
                                marginBottom: 1,
                              }}
                            >
                              Total: ₹
                              {row?.final_price === 0.0 ||
                              row?.final_price === 0
                                ? row?.price * row?.quantity
                                : row?.final_price * row?.final_quantity}
                            </Typography>
                          </Box>
                          <Divider />
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                            className="mt-2"
                          >
                            <Typography
                              variant="body2"
                              sx={{
                                color: "#333",
                                fontWeight: "500",
                                cursor: "pointer",
                                borderRadius: "12px",
                                padding: "4px 8px",
                                backgroundColor: "#f4f4f4", // Light gray background

                                transition: "background-color 0.3s",
                                "&:hover": {
                                  color: "#ff8000",
                                  backgroundColor: "#fff8e1", // Light background on hover
                                },
                              }}
                              onClick={() => handleInterestedBuyerModal(row)}
                            >
                              Buyers &rarr;
                            </Typography>

                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                backgroundColor: "#f4f4f4", // Light gray background
                                borderRadius: "12px",
                                padding: "4px 8px",
                                cursor: "pointer",
                                transition: "background-color 0.3s",
                                "&:hover": { backgroundColor: "#e0e0e0" },
                              }}
                              onClick={(e) => handleGenerateInvoice(e, row)}
                            >
                              <Typography
                                variant="body2"
                                sx={{ color: "#333", fontWeight: "500" }}
                              >
                                View Details &rarr;
                              </Typography>
                            </Box>
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <NoData val="trade" />
              )}
            </>
          ) : value === "buyer" ? (
            <SellerDependentCart
              user_id={user_id}
              value={value}
              setActiveCard={setActiveCard}
              handleRefreshButton={handleRefreshButton}
              triggerTab2Api={triggerTab2Api}
              alternateClick={alternateClick}
            />
          ) : (
            ""
          )}
        </div>
      </Box>
      <Popover
        open={Boolean(anchorElDo)}
        anchorEl={anchorElDo}
        onClose={handleCloseDo}
        anchorOrigin={{
          vertical: "center", // Align vertically with the middle of the row
          horizontal: "right", // Open to the right of the row
        }}
        transformOrigin={{
          vertical: "center", // Align the popover content to the middle of its trigger
          horizontal: "left", // Open the content from the left of the popover
        }}
        PaperProps={{ style: { maxWidth: "300px", padding: "16px" } }} // Adjust spacing
      >
        <CancelIcon
          fontSize="small"
          style={{
            color: "#1976D2",
            float: "right",
            cursor: "pointer",
            marginBottom: "10px",
          }}
          onClick={handleCloseDo}
        />
        <div>
          <div style={{ marginBottom: "10px" }}>
            <h6
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onClick={() => handleShipment(FullList)}
            >
              <span
                style={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor: "#1976D2",
                }}
              ></span>
              Invoice Generation
            </h6>
            <p style={{ marginLeft: "18px", fontSize: "14px", color: "#666" }}>
              <span
                className="steelblue cursor-pointer"
                style={{ cursor: "pointer" }}
                onClick={() => handleShipment(FullList)}
              >
                Click
              </span>{" "}
              to <b>Generate</b> Invoice.
            </p>
          </div>
          <div style={{ marginBottom: "10px" }}>
            <h6 style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span
                style={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor: FullList?.document_status?.delivered
                    ? "#1976D2"
                    : "#CCC",
                }}
              ></span>
              Dispatch Documents
            </h6>
            <p style={{ marginLeft: "18px", fontSize: "14px", color: "#666" }}>
              <span
                className="steelblue cursor-pointer"
                style={{
                  cursor: FullList?.document_status?.b2s_invoice
                    ? "pointer"
                    : "not-allowed",
                }}
                onClick={
                  FullList?.document_status?.b2s_invoice
                    ? () => handleDispatchModal(FullList)
                    : undefined
                }
              >
                Click
              </span>{" "}
              to upload your <b>Dispatch</b> documents.
            </p>
          </div>
          <div style={{ marginBottom: "10px" }}>
            <h6 style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span
                style={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor: FullList?.document_status?.delivered
                    ? "#1976D2"
                    : "#CCC",
                }}
              ></span>
              Delivery & Payments Documents
            </h6>
            <p style={{ marginLeft: "18px", fontSize: "14px", color: "#666" }}>
              Wait till the time documents are uploaded.
            </p>
          </div>

          {/* Payment Documents */}
          <div style={{ marginBottom: "10px" }}>
            <h6 style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span
                style={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor: FullList?.document_status?.delivered
                    ? "#1976D2"
                    : "#CCC",
                }}
              ></span>
              Document Action
            </h6>
            <p style={{ marginLeft: "18px", fontSize: "14px", color: "#666" }}>
              <span
                className="steelblue cursor-pointer"
                style={{
                  cursor: FullList?.document_status?.payment_proof_partner
                    ? "pointer"
                    : "not-allowed",
                }}
                onClick={
                  FullList?.document_status?.payment_proof_partner
                    ? (e) => handlePopoverOpenPayment(e, FullList)
                    : undefined
                }
              >
                Click
              </span>{" "}
              to <b>Accept</b> documents.
            </p>
          </div>
          <div style={{ marginBottom: "10px" }}>
            <h6 style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span
                style={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor:
                    FullList?.status === "Completed" ? "#1976D2" : "#CCC",
                }}
              ></span>
              Trade Completion
            </h6>
            <p style={{ marginLeft: "18px", fontSize: "14px", color: "#666" }}>
              Please wait for admin approval to mark the trade as completed.
            </p>
          </div>
        </div>
      </Popover>

      {/* <Tabs value={value} onChange={handleChangeTabs}>
          <Tab label="Trade Initiated By Me" />
          <Tab className="mx-2" label="Trade Initiated By Buyer" />
        </Tabs>
        <hr className="mt-2 mb-4" />
        <TabPanel value={value} index={0} className="CrmModuleNoPadding">
          <div className="row ">
            <div className={handleClass()} style={{ marginTop: "-35px" }}>
              <CustomTable
                rows={tableData.rows}
                columns={tableData.columns}
                paginationState={tableData.paginationState}
                loading={tableData.isLoading}
                checkboxShowFalse={tableData.checkboxShowFalse}
              />
              <Modal show={anchorEl} onHide={handlePopoverClose} size="xl">
                <Modal.Header closeButton>
                  <Modal.Title style={{ color: "" }} className="fw-bold">
                    Quality Parameters
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ padding: "2%" }}>
                  <QualityParamsModal qualityParams={qualityParams} />
                </Modal.Body>
              </Modal>
           
          
            </div>
            {widthShow ? (
            <div className="col-lg-4">
            <Card className="shadow-sm rounded-lg" style={{ height: "450px", overflow: "hidden" }}>
              <div style={{ height: "100%", overflowY: "auto" }}>
                <CardHeader style={{ borderBottom: "1px solid #eddddd" }}>
                  <h5 className="d-flex align-items-center justify-content-between">
                    <span>Details</span>
                    <span className="cursor-pointer text-primary" onClick={RevertBackWidth}>
                      Back to List <FontAwesomeIcon icon={faRotateLeft} />
                    </span>
                  </h5>
                </CardHeader>
                <CardBody className="p-2">
                  <SellerInterestedBuyerList
                    BuyersActiveId={BuyersActiveId}
                    user_id={user_id}
                    BuyersList={BuyersList}
                    setWidth={setWidth}
                    refetch={refetch}
                  />
                </CardBody>
              </div>
            </Card>
          </div>
            ) : (
              ""
            )}
          </div>
        </TabPanel>
        <TabPanel value={value} index={1} className="CrmModuleNoPadding">
          <SellerDependentCart user_id={user_id} value={value} setActiveCard={setActiveCard} />
        </TabPanel> */}
      <Modal show={show} onHide={handleClose} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>
            Dispatch Docs ( Trade Qty : {FullList?.final_quantity}{" "}
            {FullList?.unit_of_measure})
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <div class="row mt-2">
            <SellerDispatch
              FullList={FullList}
              user_id={user_id}
              refetch={refetch}
              handleClose={handleClose}
              value={value}
              stockUserId={stockUserId}
              stockCropId={stockCropId}
            />
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={BillModal} size="md" onHide={() => setBillModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            Generate Invoice ( Trade Quantity : {FullList.final_quantity} &nbsp;
            {FullList.unit_of_measure} )
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4" style={{ backgroundColor: "#F8F8F8" }}>
          <InvoiceGenerationAdmin
            stockUserId={stockUserId}
            stockCropId={stockCropId}
            procList={FullList}
            setBillModal={setBillModal}
            refetch={refetch}
            entity_type="Seller"
          />
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
      <Modal show={anchorElInvoice} onHide={handleCloseInvoice} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          {/* <ViewInvoice2 procCode={FullList.trade_procCode} invoice="invoice_1" FullList={FullList}/>    */}
          <DetailDescriptionSeller
            data={FullList}
            invoice="invoice_1"
            procCode={FullList.trade_procCode}
            type="Seller"
            user_id={user_id}
          />
          <Divider sx={{ margin: "10px 0" }} />
        </Modal.Body>
      </Modal>
      <Modal
        show={anchorElPayment}
        onHide={handlePopoverClosePayment}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        size="md"
      >
        <Modal.Header closeButton style={{ backgroundColor: "lightgrey" }}>
          <Modal.Title>Payment Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-lg-12 p-2">
              <h6 className="mx-2">
                Payment Status :{" "}
                <span className="text-warning">
                  {FullList?.payments?.partner_status}
                </span>
              </h6>
              <div
                style={{
                  padding: "10px",
                  borderRadius: "8px",
                  lineHeight: "1.6",
                }}
              >
                {FullList?.payment_records?.map((item, index) => {
                  if (item.has_partner_paid) {
                    return (
                      <div
                        key={index}
                        style={{
                          border: "1px solid #ddd",
                          borderRadius: "6px",
                          padding: "10px",
                          marginBottom: "10px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: "8px",
                          }}
                        >
                          <div>
                            <b>Amount : </b>₹ <span>{item.amount}</span>
                          </div>
                          <div>
                            <span>
                              {item.file ? (
                                <span
                                  className="text-warning cursor-pointer"
                                  onClick={() => handleViewPdf(item.file)}
                                >
                                  <PictureAsPdfIcon /> View
                                </span>
                              ) : (
                                ""
                              )}
                            </span>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <div>
                            <b>Payment Method : </b>{" "}
                            <span>
                              {item.payment_method === "Discount"
                                ? "C/D"
                                : item.payment_method}
                            </span>
                          </div>
                          <div>
                            {!item.is_confirmed ? (
                              <>
                                <span
                                  className="badge badge-success cursor-pointer mx-2"
                                  onClick={() =>
                                    handleAccept("Payment Received", item)
                                  }
                                >
                                  Accept
                                </span>
                              </>
                            ) : (
                              <span className="cursor-pointer text-warning f300 mx-2">
                                Approved
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  }
                  return null;
                })}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <ModalAnt
        title="Details"
        open={InterestedBuyerModal}
        onCancel={() => handleCloseSellerModal()}
        width={1000}
        footer={null}
        className="p-lg-2 p-0"
      >
        <BuyerInterestedForSeller
          BuyersActiveId={BuyersActiveId}
          user_id={user_id}
          BuyersList={BuyersList}
          refetch={refetch}
          setNegotiationView={setNegotiationView}
          negotiationView={negotiationView}
          setInterestedBuyerModal={setInterestedBuyerModal}
          InterestedBuyerModal={InterestedBuyerModal}
        />
      </ModalAnt>
    </Box>
  );
};

export default SellerCart;
